import React, { createContext, useState, useContext } from 'react';

const LanguageContext = createContext();

export const translations = {
  fr: {
    nav: {
      home: 'Accueil',
      services: 'Services',
      about: 'À propos',
      process: 'Processus',
      request: 'Demande',
      contact: 'Contact',
      whatsapp: 'WhatsApp'
    },
    hero: {
      eyebrow: 'OTC Crypto · Afrique francophone',
      titleStart: 'Votre passerelle simple et sécurisée vers les ',
      titleAccent: 'cryptomonnaies',
      titleEnd: ' en Afrique',
      subtitle: 'Achetez et vendez Bitcoin, USDT et d\'autres cryptos rapidement avec BiTExpress, avec un accompagnement humain à chaque étape.',
      cta1: 'Nous contacter',
      cta2: 'Découvrir nos services',
      trust: ['Disponible 7j/7', 'Transactions sécurisées', 'Accompagnement humain'],
      cardLabel: 'Achat & vente en direct',
      cardValue: 'Bitcoin · USDT'
    },
    about: {
      eyebrow: 'Qui sommes-nous',
      title: 'Une plateforme OTC pensée pour l\'Afrique francophone',
      description: 'BiTExpress permet aux particuliers, entrepreneurs et investisseurs d\'acheter et de vendre des cryptomonnaies facilement, avec un accompagnement humain et des transactions sécurisées.',
      features: [
        { title: 'Rapidité', desc: 'Des transactions exécutées en quelques minutes, sans attente inutile.' },
        { title: 'Sécurité', desc: 'Des protocoles rigoureux pour protéger chaque opération.' },
        { title: 'Accompagnement', desc: 'Une équipe réactive, joignable directement sur WhatsApp.' },
        { title: 'Simplicité', desc: 'Un parcours clair, sans jargon ni complexité technique.' }
      ]
    },
    services: {
      eyebrow: 'Ce que nous faisons',
      title: 'Nos Services',
      subtitle: 'Des solutions adaptées à vos besoins crypto, du particulier au gros volume.',
      items: [
        { title: 'Achat de cryptomonnaies', description: 'Achetez facilement Bitcoin, USDT et d\'autres actifs numériques.' },
        { title: 'Vente de cryptomonnaies', description: 'Convertissez rapidement vos cryptos en monnaie locale.' },
        { title: 'Service OTC pour gros volumes', description: 'Transactions importantes avec accompagnement personnalisé.' },
        { title: 'Réseau d\'agents crypto', description: 'Un réseau en expansion en Afrique francophone.' }
      ]
    },
    whyChoose: {
      eyebrow: 'Nos engagements',
      title: 'Pourquoi choisir BiTExpress',
      subtitle: 'Votre partenaire de confiance pour les cryptomonnaies',
      reasons: [
        { title: 'Transactions rapides', desc: 'Recevez vos fonds en quelques minutes' },
        { title: 'Support client réactif', desc: 'Équipe disponible 7j/7' },
        { title: 'Transactions sécurisées', desc: 'Protocoles de sécurité avancés' },
        { title: 'Expertise crypto et DeFi', desc: 'Équipe d\'experts à votre service' },
        { title: 'Adapté au marché africain', desc: 'Solutions pensées pour l\'Afrique' }
      ],
      marquee: ['Bitcoin', 'USDT', 'Service OTC', 'Abidjan', 'Afrique francophone', 'Sécurisé', 'Rapide', 'Accompagnement humain']
    },
    howItWorks: {
      eyebrow: 'Le processus',
      title: 'Comment ça marche',
      subtitle: 'Un processus simple en 4 étapes',
      stepLabel: 'Étape',
      steps: [
        { title: 'Contactez notre équipe', desc: 'Via WhatsApp ou email, à tout moment.' },
        { title: 'Indiquez la transaction souhaitée', desc: 'Achat ou vente, montant et actif concerné.' },
        { title: 'Confirmez la transaction', desc: 'Validation des détails et du taux ensemble.' },
        { title: 'Recevez vos fonds', desc: 'Rapidement et en toute sécurité.' }
      ],
      ctaTitle: 'Prêt à commencer ?',
      ctaText: 'Une première transaction se lance en quelques messages.',
      cta: 'Démarrer sur WhatsApp'
    },
    vision: {
      eyebrow: 'Notre vision',
      lead: 'Rendre les cryptomonnaies ',
      highlight: 'accessibles à toute l\'Afrique francophone',
      tail: ' grâce à des solutions simples, rapides et sécurisées.'
    },
    request: {
      eyebrow: 'Demande de transaction',
      title: 'Demander une transaction',
      subtitle: 'Décrivez votre besoin en quelques lignes : notre équipe vous recontacte rapidement sur WhatsApp ou par email avec une proposition.',
      steps: ['Vous envoyez votre demande', 'Nous vous recontactons sous peu', 'Vous validez et recevez vos fonds'],
      fields: {
        name: 'Nom complet',
        namePh: 'Ex. Awa Koné',
        phone: 'WhatsApp / Téléphone',
        phonePh: '+225 05 00 00 00 00',
        email: 'Email',
        emailPh: 'vous@exemple.com',
        type: 'Type de transaction',
        buy: 'Achat',
        sell: 'Vente',
        crypto: 'Cryptomonnaie',
        cryptoOptions: { BTC: 'Bitcoin (BTC)', USDT: 'USDT', OTHER: 'Autre' },
        amount: 'Montant souhaité',
        amountPh: 'Ex. 500 000 FCFA ou 1 000 USDT',
        message: 'Message (optionnel)',
        messagePh: 'Précisez votre besoin, votre ville, un délai…'
      },
      submit: 'Envoyer ma demande',
      sending: 'Envoi en cours…',
      privacy: 'Vos informations restent confidentielles et servent uniquement à traiter votre demande.',
      successTitle: 'Demande bien reçue',
      successText: 'Notre équipe vous recontacte très vite. Conservez votre référence :',
      successWhatsapp: 'Accélérer sur WhatsApp',
      another: 'Envoyer une autre demande',
      errorTitle: 'Envoi impossible',
      errorText: 'Une erreur est survenue. Réessayez ou contactez-nous directement sur WhatsApp.',
      tooMany: 'Trop de demandes envoyées. Réessayez dans un moment ou contactez-nous sur WhatsApp.'
    },
    contact: {
      eyebrow: 'Contact',
      headline: 'Parlons de votre prochaine transaction.',
      subtitle: 'Nous sommes là pour vous accompagner, du premier message jusqu\'à la réception de vos fonds.',
      whatsapp: 'Nous contacter sur WhatsApp',
      cardTitle: 'Une question ? Un volume important ?',
      cardText: 'Discutez avec notre équipe dès maintenant pour commencer vos transactions crypto.',
      email: 'Email',
      phone: 'WhatsApp',
      location: 'Ville'
    },
    footer: {
      tagline: 'Votre passerelle simple et sécurisée vers les cryptomonnaies en Afrique francophone.',
      navigation: 'Navigation',
      contact: 'Contact',
      rights: 'Tous droits réservés'
    }
  },
  en: {
    nav: {
      home: 'Home',
      services: 'Services',
      about: 'About',
      process: 'Process',
      request: 'Request',
      contact: 'Contact',
      whatsapp: 'WhatsApp'
    },
    hero: {
      eyebrow: 'OTC Crypto · French-speaking Africa',
      titleStart: 'Your simple and secure gateway to ',
      titleAccent: 'cryptocurrencies',
      titleEnd: ' in Africa',
      subtitle: 'Buy and sell Bitcoin, USDT and other cryptos quickly with BiTExpress, with human support at every step.',
      cta1: 'Contact Us',
      cta2: 'Discover Our Services',
      trust: ['Available 7/7', 'Secure transactions', 'Human support'],
      cardLabel: 'Live buy & sell',
      cardValue: 'Bitcoin · USDT'
    },
    about: {
      eyebrow: 'Who we are',
      title: 'An OTC platform built for French-speaking Africa',
      description: 'BiTExpress enables individuals, entrepreneurs and investors to buy and sell cryptocurrencies easily, with human support and secure transactions.',
      features: [
        { title: 'Speed', desc: 'Transactions executed in minutes, without needless waiting.' },
        { title: 'Security', desc: 'Rigorous protocols to protect every operation.' },
        { title: 'Support', desc: 'A responsive team, reachable directly on WhatsApp.' },
        { title: 'Simplicity', desc: 'A clear journey, free of jargon and technical complexity.' }
      ]
    },
    services: {
      eyebrow: 'What we do',
      title: 'Our Services',
      subtitle: 'Solutions tailored to your crypto needs, from individuals to large volumes.',
      items: [
        { title: 'Buy Cryptocurrencies', description: 'Easily purchase Bitcoin, USDT and other digital assets.' },
        { title: 'Sell Cryptocurrencies', description: 'Quickly convert your crypto to local currency.' },
        { title: 'OTC Service for Large Volumes', description: 'Large transactions with personalized support.' },
        { title: 'Crypto Agent Network', description: 'An expanding network across French-speaking Africa.' }
      ]
    },
    whyChoose: {
      eyebrow: 'Our commitments',
      title: 'Why Choose BiTExpress',
      subtitle: 'Your trusted partner for cryptocurrencies',
      reasons: [
        { title: 'Fast Transactions', desc: 'Receive your funds in minutes' },
        { title: 'Responsive Support', desc: 'Team available 7/7' },
        { title: 'Secure Transactions', desc: 'Advanced security protocols' },
        { title: 'Crypto & DeFi Expertise', desc: 'Expert team at your service' },
        { title: 'African Market Adapted', desc: 'Solutions designed for Africa' }
      ],
      marquee: ['Bitcoin', 'USDT', 'OTC Service', 'Abidjan', 'French-speaking Africa', 'Secure', 'Fast', 'Human support']
    },
    howItWorks: {
      eyebrow: 'The process',
      title: 'How It Works',
      subtitle: 'A simple 4-step process',
      stepLabel: 'Step',
      steps: [
        { title: 'Contact Our Team', desc: 'Via WhatsApp or email, anytime.' },
        { title: 'Specify Your Transaction', desc: 'Buy or sell, amount and asset.' },
        { title: 'Confirm Transaction', desc: 'We validate the details and rate together.' },
        { title: 'Receive Your Funds', desc: 'Quickly and securely.' }
      ],
      ctaTitle: 'Ready to start?',
      ctaText: 'Your first transaction is just a few messages away.',
      cta: 'Start on WhatsApp'
    },
    vision: {
      eyebrow: 'Our vision',
      lead: 'Making cryptocurrencies ',
      highlight: 'accessible to all of French-speaking Africa',
      tail: ' through simple, fast and secure solutions.'
    },
    request: {
      eyebrow: 'Transaction request',
      title: 'Request a transaction',
      subtitle: 'Describe your need in a few lines: our team will get back to you quickly on WhatsApp or by email with a proposal.',
      steps: ['You send your request', 'We get back to you shortly', 'You confirm and receive your funds'],
      fields: {
        name: 'Full name',
        namePh: 'E.g. Awa Koné',
        phone: 'WhatsApp / Phone',
        phonePh: '+225 05 00 00 00 00',
        email: 'Email',
        emailPh: 'you@example.com',
        type: 'Transaction type',
        buy: 'Buy',
        sell: 'Sell',
        crypto: 'Cryptocurrency',
        cryptoOptions: { BTC: 'Bitcoin (BTC)', USDT: 'USDT', OTHER: 'Other' },
        amount: 'Desired amount',
        amountPh: 'E.g. 500,000 FCFA or 1,000 USDT',
        message: 'Message (optional)',
        messagePh: 'Specify your need, your city, a deadline…'
      },
      submit: 'Send my request',
      sending: 'Sending…',
      privacy: 'Your information stays confidential and is only used to process your request.',
      successTitle: 'Request received',
      successText: 'Our team will get back to you very soon. Keep your reference:',
      successWhatsapp: 'Speed things up on WhatsApp',
      another: 'Send another request',
      errorTitle: 'Unable to send',
      errorText: 'Something went wrong. Try again or contact us directly on WhatsApp.',
      tooMany: 'Too many requests sent. Try again later or contact us on WhatsApp.'
    },
    contact: {
      eyebrow: 'Contact',
      headline: 'Let\'s talk about your next transaction.',
      subtitle: 'We are here to support you, from the first message to the receipt of your funds.',
      whatsapp: 'Contact us on WhatsApp',
      cardTitle: 'A question? A large volume?',
      cardText: 'Chat with our team now to start your crypto transactions.',
      email: 'Email',
      phone: 'WhatsApp',
      location: 'City'
    },
    footer: {
      tagline: 'Your simple and secure gateway to cryptocurrencies in French-speaking Africa.',
      navigation: 'Navigation',
      contact: 'Contact',
      rights: 'All rights reserved'
    }
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('fr');
  const t = translations[language];
  const toggleLanguage = () => setLanguage(prev => (prev === 'fr' ? 'en' : 'fr'));

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
